import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { AuthService } from './internal';

export const TENANT_KEY = 'ACTIVE_TENANT_ID';
export const LOGOUT_TIMEOUT_MS = 250; // .25 seconds

@Injectable({
    providedIn: 'root',
})
export class HeaderService {
    private readonly authService = inject(AuthService);

    public get onInitialized(): ReplaySubject<boolean> {
        return this.authService.onInitialized;
    }

    public get loggedIn(): Observable<boolean> {
        return this.authService.checkAuthenticatedOrLogin();
    }

    public config = this.authService.config;

    public isAuthenticated = this.authService.isAuthenticated.bind(this.authService);
    public getToken = this.authService.getToken.bind(this.authService);
    public refreshToken = this.authService.refreshToken.bind(this.authService);
    public login = this.authService.login.bind(this.authService);
    public logout = this.authService.logout.bind(this.authService);
    public getClaims = this.authService.getIdentityClaims.bind(this.authService);
}
